import { ClassItem } from "../Types/ClassItem";

const sanitiseString = (inputString?: string | null): string => {
  if (inputString == null) {
    return "";
  }

  // Replace spaces and other non-alphanumeric characters with a single hyphen
  const result = inputString
    .replace(/\s+/g, "-") // Replace spaces with hyphens
    .replace(/[^a-zA-Z0-9-]+/g, "") // Remove other non-alphanumeric characters
    .replace(/-{2,}/g, "-"); // Replace consecutive hyphens with a single hyphen

  return result.toLowerCase();
};

const concatStringFromClassesArrayList = (props: ClassItem): string => {
  const classList = [
    props.defaultClass?.trim(),
    ...(props.optionalClasses || []).filter(
      (name) => name !== null && name !== undefined && name !== ""
    ),
  ]
    .join(" ")
    .trim();
  return classList;
};

export { sanitiseString, concatStringFromClassesArrayList };
